import { CDN_IMAGE_PATH, S3_IMAGE_PATH } from '../Constants'
import { DateTime } from 'luxon'

export const formatImageString = (
  src: string,
  maxHeight: number = 1080
): string => {
  const newSrc: string = `${src.replace(
    S3_IMAGE_PATH,
    CDN_IMAGE_PATH
  )}&h=${maxHeight}`

  return newSrc
}

export function toRelative(date: DateTime | Date): string {
  const datetime = date instanceof DateTime ? date : DateTime.fromJSDate(date)
  if (Math.abs(datetime.diffNow().as('minutes')) < 1) return 'just now'
  return datetime.toRelative() ?? 'a few moments'
}

export function checkDaysAgo(date: DateTime | Date, amount: number): boolean {
  const past = date instanceof DateTime ? date : DateTime.fromJSDate(date)
  return Math.abs(past.diffNow().as('days')) > amount
}
